<!-- 邮件会话预览界面 -->
<template>
    <div id="threadPreview">
        <!-- 会话主题 -->
        <div class="thread-subject">
            {{thread.folderName}}
        </div>
        <!-- 邮件预览 -->
        <el-scrollbar style='height:calc(100% - 70px);' ref="elscrollbar">
            <div style="padding-right:30px;margin-bottom: 20px;" :key="index" v-for="(email,index) in emails">
                <div v-if="haveDevelop(index)">
                    <emailPage ref="emailPage" :email="email"></emailPage>
                    <!-- 分割线 -->
                    <hr v-show="emails.length>1">
                </div>
                <!-- 邮件缩略 -->
                <div class="emails-abbreviation" v-if="index==0&&!isDevelop&&emails.length>4">
                    <div class="emails-abbreviation-btn" @click="isDevelop=true">
                        <img src="../../assets/images/vectorImg/icon_hide_mail_expand.svg">
                        <span>{{emails.length - 3}}</span></div>
                    <hr>
                </div>
            </div>
        </el-scrollbar>
    </div>
</template>
<script>
import emailPage from "@/components/preview/email_exploer";
export default {
    props: ["thread","emails"],
    components: {
        emailPage,
    },
    data() {
        return {
            isDevelop: false,//大于四封邮件以上，是否展开显示所有邮件简略信息
        }
    },
    methods: {
        init(){
           
        },
        //是否缩略邮件
        haveDevelop(index){
            if(this.emails.length>4&&!this.isDevelop){
                let last = this.emails.length - 2;
                if(index>0&&index<last){
                    //第一封以后到倒数第三封邮件全部隐藏
                    return false;
                }
            }
            return true;
        }
    }
}
</script>
<style scoped>
#threadPreview {
    height: 100%;
    padding-left: 30px;/*no*/
}

.thread-subject {
    height: 70px;/*no*/
    line-height: 70px;/*no*/
    font-size: 24px;/*no*/
    font-family: Arial;
    font-weight: bold;
    padding-right: 30px;/*no*/
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

hr {
    background: #DDDDDD;
    border: 0;
    height: 1px;/*no*/
    margin: 8px 0 !important;/*no*/
}

.emails-abbreviation {
    position: relative;
}

.emails-abbreviation-btn {
    position: absolute;
    border: 1px solid #DDDDDD;/*no*/
    border-radius: 12px;/*no*/
    min-width: 48px;/*no*/
    height: 23px;/*no*/
    top: -16px;/*no*/
    background: #FFFFFF;
    font-size: 14px;/*no*/
    font-family: Arial;
    font-weight: 400;
    line-height: 23px;/*no*/
    color: #6F7886;
    text-align: center;
    padding: 0 5px;/*no*/
    cursor: pointer;
}

.emails-abbreviation-btn:hover {
    background: #E6E6E6;
}

.emails-abbreviation-btn img{
    display: none;
}

.emails-abbreviation-btn:hover img{
    display: unset;
}

.emails-abbreviation-btn:hover span{
    display: none;
}
</style>


// WEBPACK FOOTER //
// src/components/workspace/thread_preview.vue